<template>

  <div>

    <t-page-form-upload
        :type-image="typeImage"
        :command="command"
        :other-entity="otherEntity"
        :path="path" :primaryKeyColumn="primaryKeyColumn" :foreign-key-column="foreignKeyColumn"
        :primary-key="form.enterpriseContentFileId" :foreign-key="form.enterpriseContentId"
        :items="items" :user-auth="userAuth" :status="status"
        :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
        :message-not-record="messageNotRecord"
        :only-view="onlyView"
        @onSubmit="onSubmit" @itemDownload="onItemFileDownload" @onItemDelete="onItemDeleteDefault"
        @onUploadComplete="onUploadComplete" @onRequestList="getList">

    </t-page-form-upload>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin";
import pageFormUploadMixin from "@/mixins/page/pageFormUploadMixin";
import tPageFormUpload from "@/components/template/page/t-page-form-upload";
import SharingFileType from "@/model/types/resource/SharingFileType";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin, pageFormUploadMixin],
  components: {tPageFormUpload},
  name: 'EnterpriseFile',
  data() {
    return {
      SharingFileType,
      path: "place/enterprise-content-file", //Utilizar somente quando fora do padrão
      primaryKeyColumn: "enterpriseContentFileId",
      foreignKeyColumn: "enterpriseContentId", //Utilizar quando usar Tabs com outros componentes
      type: "I", //Tipo padrão de modelo de envio de arquivos poderá ser I ou D
      form: {
        enterpriseContentId: this.foreignKey,
        enterpriseContentFileId: 0,
        orderList: 0,
        type: "",
        fileEntity: {
          nameOriginal: "",
          nameSave: "",
          sizeKb: 0,
          extension: "",
        }
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    otherEntity: Boolean,
  },
  methods: {

    defaultForm() {
      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()
    },

    mountedPrepare() {

      if (this.otherEntity) {
        this.command = 'view'
      }

      this.mountedPrepareFormUploadDefault()

    },

    async mountedContinued() {

      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.enterpriseContentFileId)

    },

    mountedList() {

      // Manipulação da listagem após carregando
      //--------------------------------------

      //--------------------------------------

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
